/**
 * Collection UX: device selector triggers and model-filter session state.
 * Opens global device selector via [data-aioo-open-device-selector].
 */
(function () {
  'use strict';

  function trackUxEvent(name, payload) {
    var data = payload || {};
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, data));
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, data);
      }
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', name, data);
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
      }
    } catch (e) { /* non-blocking */ }
  }
  window.AIOO_trackUxEvent = trackUxEvent;

  function openCollectionFiltersDrawer() {
    if (!document.getElementById('aioo-picker-cta')) return false;
    var trigger = document.querySelector('[data-aioo-open-collection-filters]');
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  }

  function openDeviceSelector() {
    var launch = function () {
      try {
        if (window.jQuery && jQuery.magnificPopup) {
          jQuery.magnificPopup.open({
            items: { src: '#DeviceSelector' },
            type: 'inline',
            mainClass: 'mfp-zoom-in',
            removalDelay: 300
          });
          return;
        }
      } catch (e) { /* fall through */ }
      var btn = document.querySelector('.DeviceSelectorBtn');
      if (btn) {
        btn.click();
        return;
      }
      var el = document.getElementById('DeviceSelector');
      if (el) el.style.display = 'block';
    };

    if (typeof window.AIOO_modelsMatch === 'function' || typeof window.aiooEnsureModelNormalize !== 'function') {
      launch();
      return;
    }
    window.aiooEnsureModelNormalize().then(launch).catch(launch);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aioo-open-device-selector]');
    if (!btn) return;
    e.preventDefault();
    var path = window.location.pathname || '';
    /* Leaf case collections have no in-page filter that can switch model.
       Load the cases hub picker so a choice navigates to that model's collection. */
    if (btn.getAttribute('data-aioo-model-picker') === 'cases') {
      window.AIOO_deviceSelectorCollectionOnce = 'smartphone-cases';
      document.dispatchEvent(new CustomEvent('aioo:device-selector-reload'));
      openDeviceSelector();
      if (typeof window.AIOO_trackUxEvent === 'function') {
        window.AIOO_trackUxEvent('model_picker_open', { source: 'collection_model_chip', page_path: path });
      }
      return;
    }
    if (path.indexOf('/collections/') !== -1 && openCollectionFiltersDrawer()) {
      if (typeof window.AIOO_trackUxEvent === 'function') {
        window.AIOO_trackUxEvent('model_picker_open', { source: 'collection_redirect', page_path: path });
      }
      return;
    }
    openDeviceSelector();
  });

  document.addEventListener('click', function (e) {
    var openFilters = e.target.closest('[data-aioo-open-collection-filters]');
    if (!openFilters || typeof window.AIOO_trackUxEvent !== 'function') return;
    window.AIOO_trackUxEvent('model_picker_open', {
      source: 'collection_filters_drawer',
      page_path: window.location.pathname
    });
  });

  function getCompatibleModelFromUrl(urlObj) {
    if (typeof window.AIOO_resolveUserDisplayModel === 'function') {
      return window.AIOO_resolveUserDisplayModel(urlObj, null, 'AIOO_selectedDevice');
    }
    var hit = null;
    urlObj.searchParams.forEach(function (val, key) {
      if (key.indexOf('compatible_model') !== -1) hit = val;
    });
    return hit;
  }

  function hasCompatibleModelFilter(urlObj) {
    var found = false;
    urlObj.searchParams.forEach(function (_val, key) {
      if (key.indexOf('compatible_model') !== -1) found = true;
    });
    return found;
  }

  function normalizeStoredSlug(value) {
    return String(value || '').replace(/\s+/g, ' ').replace(/\s*,\s*/g, ', ').trim().toLowerCase();
  }

  function setCompatibleModelParam(urlObj, paramName, modelValue) {
    var param = paramName || 'filter.v.m.custom.compatible_model';
    var canonical = normalizeStoredSlug(modelValue);
    var slugs = typeof window.AIOO_expandSlugForFilter === 'function'
      ? window.AIOO_expandSlugForFilter(canonical)
      : [canonical];
    var keys = [];
    urlObj.searchParams.forEach(function (_, key) {
      if (key.indexOf('compatible_model') !== -1) keys.push(key);
    });
    keys.forEach(function (key) { urlObj.searchParams.delete(key); });
    var seen = {};
    slugs.forEach(function (slug) {
      var s = normalizeStoredSlug(slug);
      if (!s || seen[s]) return;
      seen[s] = true;
      urlObj.searchParams.append(param, s);
    });
    if (typeof window.AIOO_setUserModelParam === 'function') {
      window.AIOO_setUserModelParam(urlObj, canonical);
    } else if (canonical) {
      urlObj.searchParams.set('aioo_model', canonical);
    } else {
      urlObj.searchParams.delete('aioo_model');
    }
  }

  function initCollectionModelSession() {
    var cta = document.getElementById('aioo-picker-cta');
    if (!cta) return;

    var LS_KEY = 'AIOO_selectedDevice';
    var H1_VARIANT_KEY = 'AIOO_h1_variant';
    var chipWrap = document.getElementById('aioo-picker-chip');
    var stateModel = document.getElementById('aioo-picker-model');
    var chipCount = document.getElementById('aioo-picker-count');
    var clearBtn = document.getElementById('aioo-picker-clear');
    var collectionTitle = document.querySelector('[data-aioo-collection-title]');
    var collectionSubtitle = document.querySelector('[data-aioo-collection-subtitle]');
    var filterParam = cta.getAttribute('data-filter-param') || 'filter.v.m.custom.compatible_model';
    var currentUrl = new URL(window.location.href);
    var hasModelFilter = hasCompatibleModelFilter(currentUrl);
    var displayModelSlug = getCompatibleModelFromUrl(currentUrl);
    var modelFromStorage = localStorage.getItem(LS_KEY);
    var stickyBar = null;
    var stickyModel = null;
    var stickyVisible = false;
    var lastTrackedModel = null;
    var h1Variant = localStorage.getItem(H1_VARIANT_KEY);

    if (h1Variant !== 'a' && h1Variant !== 'b') {
      h1Variant = Math.random() < 0.5 ? 'a' : 'b';
      localStorage.setItem(H1_VARIANT_KEY, h1Variant);
    }

    function modelFilterKey(value) {
      return normalizeStoredSlug(value);
    }

    function formatModelDisplay(value) {
      var raw = modelFilterKey(value);
      if (typeof window.AIOO_formatModelLabel === 'function') {
        return window.AIOO_formatModelLabel(raw);
      }
      var key = raw;
      if (!key || key.indexOf('gid://') === 0) return '';
      if (key === 'iphone 16e') return 'iPhone 16e';
      if (key === 'iphone air') return 'iPhone Air';
      if (key === 'iphone x/xs') return 'iPhone X/XS';
      var special = {
        '5g': '5G', '4g': '4G', iphone: 'iPhone', galaxy: 'Galaxy', se: 'SE', fe: 'FE',
        pro: 'Pro', max: 'Max', plus: 'Plus', mini: 'Mini', ultra: 'Ultra', air: 'Air',
        note: 'Note', redmi: 'Redmi', xiaomi: 'Xiaomi', huawei: 'Huawei', oneplus: 'OnePlus',
        nokia: 'Nokia', airpods: 'AirPods'
      };
      return key.split(' ').map(function (word) {
        return special[word] || (word.charAt(0).toUpperCase() + word.slice(1));
      }).join(' ');
    }

    function normalizeModelName(value) {
      return formatModelDisplay(value);
    }

    function ensureStickyBar() {
      if (stickyBar) return stickyBar;
      stickyBar = document.createElement('div');
      stickyBar.className = 'aioo-model-stickybar';
      stickyBar.setAttribute('aria-live', 'polite');
      stickyBar.innerHTML =
        '<span class="aioo-model-stickybar__label">Filtrs:</span>' +
        '<strong class="aioo-model-stickybar__model"></strong>' +
        '<button type="button" class="aioo-model-stickybar__btn" data-aioo-open-device-selector>Mainīt</button>' +
        '<button type="button" class="aioo-model-stickybar__btn aioo-model-stickybar__btn--clear" data-aioo-clear-device-filter>Notīrīt</button>';
      document.body.appendChild(stickyBar);
      stickyModel = stickyBar.querySelector('.aioo-model-stickybar__model');
      return stickyBar;
    }

    function formatProductCount(count) {
      var n = parseInt(count, 10) || 0;
      if (n === 1) return '1 prece';
      return n + ' preces';
    }

    function updateStickyVisibility(hasModel) {
      var bar = ensureStickyBar();
      if (!hasModel) {
        bar.classList.remove('is-visible');
        cta.classList.remove('aioo-picker-cta--sticky-hidden');
        stickyVisible = false;
        return;
      }
      var ctaRect = cta.getBoundingClientRect();
      var shouldShow = ctaRect.bottom < 0;
      if (shouldShow !== stickyVisible) {
        bar.classList.toggle('is-visible', shouldShow);
        cta.classList.toggle('aioo-picker-cta--sticky-hidden', shouldShow);
        stickyVisible = shouldShow;
      }
    }

    function updateStateUI(value) {
      var normalizedValue = normalizeModelName(value);
      var has = normalizedValue.length >= 2;
      cta.dataset.hasModel = has ? 'true' : 'false';
      cta.classList.toggle('aioo-picker-cta--done', has);
      if (chipWrap) chipWrap.hidden = !has;
      if (stateModel && has) stateModel.textContent = normalizedValue;
      if (stateModel && !has) stateModel.textContent = '';
      if (chipCount) {
        var count = parseInt(cta.getAttribute('data-product-count'), 10) || 0;
        chipCount.textContent = formatProductCount(count);
        chipCount.hidden = count < 1;
      }
      ensureStickyBar();
      if (stickyModel) stickyModel.textContent = has ? normalizedValue : '';
      if (collectionTitle) {
        var defaultTitle = collectionTitle.getAttribute('data-default-title') || '';
        collectionTitle.textContent = defaultTitle;
      }
      if (collectionSubtitle) {
        var modelLabel = collectionSubtitle.querySelector('[data-aioo-model-label]');
        var keepSwitch = collectionSubtitle.getAttribute('data-aioo-model-picker') === 'cases';
        if (has) {
          if (modelLabel) modelLabel.textContent = normalizedValue;
          else collectionSubtitle.textContent = normalizedValue;
          collectionSubtitle.hidden = false;
          collectionSubtitle.classList.remove('v-hidden');
        } else if (modelLabel) {
          modelLabel.textContent = '';
          collectionSubtitle.hidden = !keepSwitch;
          collectionSubtitle.classList.toggle('v-hidden', !keepSwitch);
        } else {
          collectionSubtitle.textContent = '';
          collectionSubtitle.hidden = true;
          collectionSubtitle.classList.add('v-hidden');
        }
      }
      if (has && normalizedValue !== lastTrackedModel) {
        trackUxEvent('aioo_model_filter_active', {
          model_name: normalizedValue,
          title_variant: h1Variant,
          page_path: window.location.pathname
        });
        lastTrackedModel = normalizedValue;
      }
      updateStickyVisibility(has);
    }

    function clearSelectedModel() {
      localStorage.removeItem(LS_KEY);
      var next = new URL(window.location.href);
      var keys = [];
      next.searchParams.forEach(function (_, key) {
        if (key.indexOf('compatible_model') !== -1 || key === 'aioo_model') keys.push(key);
      });
      keys.forEach(function (key) { next.searchParams.delete(key); });
      updateStateUI('');
      trackUxEvent('aioo_model_filter_cleared', {
        source: 'clear_action',
        page_path: window.location.pathname
      });
      if (keys.length) window.location.href = next.toString();
    }

    function syncDisplayFromUrl(url, source) {
      var slug = getCompatibleModelFromUrl(url);
      if (slug) {
        var key = modelFilterKey(slug);
        if (key) localStorage.setItem(LS_KEY, key);
        updateStateUI(formatModelDisplay(slug));
        trackUxEvent('aioo_model_filter_hydrated', {
          source: source || 'url',
          model_name: formatModelDisplay(slug),
          title_variant: h1Variant,
          page_path: window.location.pathname
        });
        return true;
      }
      localStorage.removeItem(LS_KEY);
      updateStateUI('');
      return false;
    }

    function mismatchStorageKey() {
      return 'AIOO_stickyModelSkip:' + window.location.pathname;
    }

    function readSkippedMismatchModel() {
      try { return sessionStorage.getItem(mismatchStorageKey()); } catch (_e) { return null; }
    }

    function rememberMismatchModel(key) {
      try { sessionStorage.setItem(mismatchStorageKey(), key); } catch (_e) { /* ignore */ }
    }

    function forgetMismatchModel() {
      try { sessionStorage.removeItem(mismatchStorageKey()); } catch (_e) { /* ignore */ }
    }

    function mismatchStrings() {
      return {
        text: cta.getAttribute('data-i18n-mismatch') || '',
        change: cta.getAttribute('data-i18n-mismatch-change') || '',
        dismiss: cta.getAttribute('data-i18n-mismatch-dismiss') || ''
      };
    }

    function hideStickyModelMismatchNotice() {
      var old = document.getElementById('aioo-sticky-mismatch');
      if (old) old.remove();
    }

    function showStickyModelMismatchNotice(modelLabel) {
      hideStickyModelMismatchNotice();
      var strings = mismatchStrings();
      if (!strings.text) return;

      var notice = document.createElement('div');
      notice.id = 'aioo-sticky-mismatch';
      notice.className = 'aioo-sticky-mismatch';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');

      var textEl = document.createElement('span');
      textEl.className = 'aioo-sticky-mismatch__text';
      textEl.textContent = strings.text.replace('@@MODEL@@', modelLabel);
      notice.appendChild(textEl);

      var actions = document.createElement('span');
      actions.className = 'aioo-sticky-mismatch__actions';

      var changeBtn = document.createElement('button');
      changeBtn.type = 'button';
      changeBtn.className = 'aioo-sticky-mismatch__btn';
      changeBtn.setAttribute('data-aioo-open-device-selector', '');
      changeBtn.textContent = strings.change;
      actions.appendChild(changeBtn);

      if (strings.dismiss) {
        var closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'aioo-sticky-mismatch__close';
        closeBtn.setAttribute('aria-label', strings.dismiss);
        closeBtn.innerHTML = '&times;';
        closeBtn.addEventListener('click', hideStickyModelMismatchNotice);
        actions.appendChild(closeBtn);
      }

      notice.appendChild(actions);
      cta.insertAdjacentElement('afterend', notice);
    }

    /**
     * The sticky device filter (localStorage.AIOO_selectedDevice) is meant to
     * carry a customer's phone model across category browsing — collection_picker_hint
     * literally advertises this ("filter persists between categories"). But
     * blindly re-applying it on every collection via an immediate
     * location.replace() could land someone fresh off the nav menu straight
     * on a zero-result page for a category that simply has no products for
     * their remembered model (e.g. "Kabeļi un adapteri" cables, which are
     * mostly universal, not phone-specific) — a silent dead end that reads
     * as a broken filter. Verify the filter actually returns products for
     * THIS collection first (reusing the ajax preview fetch from
     * assets/collection-model-filter-ajax.js); only commit it if it does,
     * otherwise leave the unfiltered page as-is and surface a dismissible
     * explanation instead.
     */
    function verifyAndApplyModelFilter(modelKey, modelLabel, opts) {
      opts = opts || {};
      var target = new URL(window.location.href);
      setCompatibleModelParam(target, filterParam, modelKey);
      var previewPath = target.pathname + target.search;

      if (typeof window.AIOO_fetchCollectionDoc !== 'function') {
        window.location.href = target.toString();
        return;
      }

      window.AIOO_fetchCollectionDoc(previewPath).then(function (doc) {
        var freshCta = doc.getElementById('aioo-picker-cta');
        var count = freshCta ? (parseInt(freshCta.getAttribute('data-product-count'), 10) || 0) : null;

        if (count === 0) {
          rememberMismatchModel(modelKey);
          showStickyModelMismatchNotice(modelLabel);
          if (opts.onEmpty) opts.onEmpty();
          return;
        }

        forgetMismatchModel();
        hideStickyModelMismatchNotice();
        if (window.history && window.history.pushState) {
          window.history.pushState({ aiooMbfFilter: true }, '', previewPath);
        }
        if (typeof window.AIOO_applyCollectionResponseToDom === 'function') {
          window.AIOO_applyCollectionResponseToDom(doc);
          syncDisplayFromUrl(new URL(window.location.href), opts.source || 'storage');
        } else {
          window.location.href = target.toString();
        }
      }).catch(function () {
        if (opts.onError) opts.onError();
      });
    }

    var ssrDisplay = cta.getAttribute('data-active-model-display');
    var ssrKey = cta.getAttribute('data-active-model-key');

    if (hasModelFilter) {
      syncDisplayFromUrl(currentUrl, 'url');
    } else if (modelFromStorage) {
      var keyFromStorage = modelFilterKey(modelFromStorage);
      var normalizedFromStorage = formatModelDisplay(modelFromStorage);
      if (!keyFromStorage) {
        localStorage.removeItem(LS_KEY);
        updateStateUI('');
        return;
      }
      updateStateUI('');
      if (readSkippedMismatchModel() === keyFromStorage) {
        showStickyModelMismatchNotice(normalizedFromStorage);
      } else {
        trackUxEvent('aioo_model_filter_hydrated', {
          source: 'storage',
          model_name: normalizedFromStorage,
          title_variant: h1Variant,
          page_path: window.location.pathname
        });
        verifyAndApplyModelFilter(keyFromStorage, normalizedFromStorage, { source: 'storage' });
      }
    } else if (ssrDisplay) {
      updateStateUI(ssrDisplay);
    } else {
      updateStateUI('');
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', clearSelectedModel);
    }

    /* assets/collection-model-filter-ajax.js's "Visi filtri" model picker
       updates the URL via history.pushState and swaps the grid/sidebar
       without a full page reload — everything above this point only runs
       once on the initial DOMContentLoaded, so picking a different model
       there left this CTA's model name frozen on stale text and never
       refreshed localStorage.AIOO_selectedDevice (which then re-applied the
       OLD model as a silent redirect on the next fresh collection page load
       too, compounding the confusion). Re-run the same URL->state sync (not
       the modelFromStorage redirect branch — no reload is happening here) on
       that event. */
    document.addEventListener('aioo:collection-filters-updated', function () {
      syncDisplayFromUrl(new URL(window.location.href), 'ajax_filter');
    });

    document.addEventListener('aioo:device:changed', function (e) {
      var raw = e && e.detail ? e.detail.device : '';
      var modelKey = modelFilterKey(raw);
      var modelLabel = formatModelDisplay(raw);
      if (!modelKey) return;
      localStorage.setItem(LS_KEY, modelKey);
      forgetMismatchModel();
      trackUxEvent('aioo_model_filter_selected', {
        model_name: modelLabel,
        title_variant: h1Variant,
        source: 'device_selector',
        page_path: window.location.pathname
      });
      var target = new URL(window.location.href);
      setCompatibleModelParam(target, filterParam, modelKey);
      if (target.toString() === window.location.href) {
        updateStateUI(modelLabel);
        return;
      }
      verifyAndApplyModelFilter(modelKey, modelLabel, {
        source: 'device_selector',
        onEmpty: function () { updateStateUI(''); }
      });
    });

    document.addEventListener('click', function (e) {
      var openAction = e.target.closest('[data-aioo-open-device-selector]');
      if (openAction) {
        trackUxEvent('aioo_model_selector_opened', {
          source: openAction.className || 'unknown',
          page_path: window.location.pathname
        });
      }
      var clearAction = e.target.closest('[data-aioo-clear-device-filter]');
      if (!clearAction) return;
      e.preventDefault();
      clearSelectedModel();
    });

    ensureStickyBar();
    var stickyRafPending = false;
    function scheduleStickyVisibilityUpdate() {
      if (stickyRafPending) return;
      stickyRafPending = true;
      window.requestAnimationFrame(function () {
        stickyRafPending = false;
        updateStickyVisibility(cta.dataset.hasModel === 'true');
      });
    }
    window.addEventListener('scroll', scheduleStickyVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyVisibilityUpdate, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionModelSession);
  } else {
    initCollectionModelSession();
  }

  /**
   * Cart drawer lazy load: initial HTML is a minimal shell (~30 lines).
   * Full drawer markup loads on first cart-icon click or add-to-cart
   * via Section Rendering API.
   */
  var cartDrawerLoadPromise = null;

  function cartDrawerMarkupBroken(drawer) {
    if (!drawer) return false;
    var html = drawer.innerHTML;
    return html.indexOf('buttontype') !== -1 || html.indexOf('<aid=') !== -1;
  }

  function isCartDrawerLazy() {
    var drawer = document.querySelector('cart-drawer[data-aioo-lazy]');
    return drawer && drawer.getAttribute('data-aioo-lazy') === 'pending';
  }

  function initDrawerParcelSelect2() {
    /* Parcel select lived in drawer shipping picker — removed; no-op for legacy calls. */
  }

  function bindCartDrawerPageLinks(root) {
    var scope = root || document;
    scope.querySelectorAll('#inlinecheckout-cart, #CartDrawer-Checkout').forEach(function (link) {
      if (!link.closest('cart-drawer') || link.tagName !== 'A') return;
      link.setAttribute('data-aioo-cart-page', '');
      if (link.dataset.aiooCartBound === '1') return;
      link.dataset.aiooCartBound = '1';
      link.addEventListener('click', function () {
        var drawer = link.closest('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
      });
    });
  }

  function runSectionScripts(doc) {
    doc.querySelectorAll('script').forEach(function (scriptEl) {
      if (scriptEl.src) return;
      var code = (scriptEl.textContent || '').trim();
      if (!code) return;
      var ns = document.createElement('script');
      ns.textContent = code;
      document.body.appendChild(ns);
    });
  }

  function injectCartDrawerStyles(doc) {
    if (document.getElementById('aioo-cart-drawer-styles')) return;
    var styles = doc.querySelectorAll('style');
    if (!styles.length) return;
    var marker = document.createElement('style');
    marker.id = 'aioo-cart-drawer-styles';
    var css = '';
    styles.forEach(function (styleEl) {
      css += styleEl.textContent || '';
    });
    marker.textContent = css;
    document.head.appendChild(marker);
  }

  function injectCartDrawerSection(sectionHtml) {
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    injectCartDrawerStyles(doc);
    var fresh = doc.querySelector('cart-drawer');
    if (!fresh) return null;
    fresh.setAttribute('data-aioo-lazy', 'loaded');
    var old = document.querySelector('cart-drawer');
    if (old) {
      old.replaceWith(fresh);
    } else {
      document.body.appendChild(fresh);
    }
    runSectionScripts(doc);
    initDrawerParcelSelect2();
    bindCartDrawerPageLinks(fresh);
    document.dispatchEvent(new CustomEvent('aioo:cart-drawer-loaded'));
    return fresh;
  }

  function ensureCartDrawerLoaded() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && cartDrawerMarkupBroken(drawer)) {
      cartDrawerLoadPromise = null;
    } else if (drawer && !isCartDrawerLazy()) {
      return Promise.resolve(drawer);
    }
    if (cartDrawerLoadPromise) return cartDrawerLoadPromise;

    var base = window.shopUrl || window.location.origin;
    cartDrawerLoadPromise = fetch(base + '/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var sectionHtml = data && data['cart-drawer'];
        if (!sectionHtml) throw new Error('cart-drawer section missing');
        return injectCartDrawerSection(sectionHtml);
      })
      .catch(function (err) {
        cartDrawerLoadPromise = null;
        throw err;
      });
    return cartDrawerLoadPromise;
  }

  window.AIOO_ensureCartDrawer = ensureCartDrawerLoaded;

  function isCartPageHref(el) {
    if (!el || el.tagName !== 'A') return false;
    var href = el.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    try {
      return /\/cart\/?$/.test(new URL(href, window.location.origin).pathname);
    } catch (err) {
      return href === '/cart' || href.indexOf('/cart?') === 0;
    }
  }

  function shouldOpenCartDrawerOnClick(trigger) {
    if (!trigger) return false;
    if (trigger.hasAttribute('data-aioo-cart-page')) return false;
    if (trigger.id === 'inlinecheckout-cart' || trigger.id === 'CartDrawer-Checkout') return false;
    if (trigger.closest('cart-drawer') && isCartPageHref(trigger)) return false;
    return !!trigger.closest('#cartLink, #cartLinkDesktop, #altcartLink, [data-header-cart-link], [data-cart-drawer]') ||
      (trigger.matches('a[href]') && isCartPageHref(trigger) && !trigger.closest('cart-drawer'));
  }

  /**
   * Never jump straight to /checkout from storefront links — delivery
   * (Omniva pakomāts) is saved only on /cart via shipping-method-picker.
   * Drawer CTAs already point at /cart (data-aioo-cart-page).
   */
  function initCheckoutRequiresCartGuard() {
    /* Keep in sync with aioo_cart_delivery_picker in sections/cart-template.liquid. True while the delivery
       (locker) is chosen in the cart: links to /checkout go to /cart first. It was false 2026-10-05 to
       2026-10-06 (picker retired). Set both to false to let links go straight to /checkout. */
    var CHECKOUT_REQUIRES_CART = true;
    if (!CHECKOUT_REQUIRES_CART) return;
    if (document.documentElement.dataset.aiooCheckoutCartGuard === '1') return;
    document.documentElement.dataset.aiooCheckoutCartGuard = '1';
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!link) return;
        if (link.hasAttribute('data-aioo-cart-page')) return;
        var href = link.getAttribute('href') || '';
        var path = '';
        try {
          path = new URL(href, window.location.origin).pathname;
        } catch (err) {
          return;
        }
        if (path !== '/checkout' && path.indexOf('/checkouts/') !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      },
      true
    );
  }

  function initCartDrawerLazy() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && cartDrawerMarkupBroken(drawer)) {
      ensureCartDrawerLoaded();
    } else {
      bindCartDrawerPageLinks(drawer);
    }

    initCheckoutRequiresCartGuard();

    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest('a[href], button');
        if (!trigger || !isCartDrawerLazy() || !shouldOpenCartDrawerOnClick(trigger)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        ensureCartDrawerLoaded().then(function (d) {
          if (d && typeof d.open === 'function') d.open(trigger);
        });
      },
      true
    );

    document.addEventListener(
      'submit',
      function (e) {
        var productForm = e.target.closest('product-form');
        if (!productForm || !isCartDrawerLazy()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        ensureCartDrawerLoaded().then(function () {
          var form = productForm.querySelector('form');
          if (form) form.requestSubmit();
        });
      },
      true
    );

    document.addEventListener('aioo:cart-drawer-loaded', function (e) {
      bindCartDrawerPageLinks(e.target || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerLazy);
  } else {
    initCartDrawerLazy();
  }

  /** Flickity carousels (related products, etc.): lazysizes skips 0-width offscreen cells. */
  function refreshCarouselLazyImages(scope) {
    if (!window.lazySizes || !window.lazySizes.loader) return;
    try {
      window.lazySizes.loader.checkElems(scope || document);
    } catch (e) { /* non-blocking */ }
  }

  /**
   * Equal-height carousel cards. Flickity positions cells absolutely, so the
   * flex `align-items: stretch` equal-height never applies and cards end up
   * ragged (a swatch row or a leasing line makes some taller). Level them to
   * the tallest card's height. Reset first so repeat calls (resize) don't grow.
   */
  function equalizeCarouselCards(carousel) {
    var cards = carousel.querySelectorAll('.grid-view-item');
    if (cards.length < 2) return;
    var i, max = 0;
    for (i = 0; i < cards.length; i++) { cards[i].style.minHeight = ''; }
    for (i = 0; i < cards.length; i++) {
      var h = cards[i].offsetHeight;
      if (h > max) max = h;
    }
    if (max > 0) {
      for (i = 0; i < cards.length; i++) { cards[i].style.minHeight = max + 'px'; }
    }
  }

  function bindCarouselLazyImages(carousel) {
    if (!carousel || carousel.getAttribute('data-aioo-lazy-bound') === '1') return;
    carousel.setAttribute('data-aioo-lazy-bound', '1');

    var tick = function () {
      refreshCarouselLazyImages(carousel);
      equalizeCarouselCards(carousel);
    };

    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.flickity) {
      var $carousel = window.jQuery(carousel);
      $carousel.on('ready.flickity settle.flickity select.flickity resize.flickity', tick);
      if ($carousel.hasClass('flickity-enabled')) {
        tick();
      }
    } else {
      tick();
    }
  }

  function initCarouselLazyImages() {
    document.querySelectorAll('.grid-products.carousel[data-flickity]').forEach(bindCarouselLazyImages);
    refreshCarouselLazyImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarouselLazyImages);
  } else {
    initCarouselLazyImages();
  }

  document.addEventListener('shopify:section:load', initCarouselLazyImages);

  // Shopify localization redirect often drops ?query — keep path + search + hash
  // so mid-flow pages (sell-your-device ?device_type=&flow=) survive language changes.
  function ensureLocalizationReturnTo(form) {
    if (!form || !form.querySelector('input[name="locale_code"]')) return;
    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    var input = form.querySelector('input[name="return_to"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'return_to';
      form.appendChild(input);
    }
    input.value = returnTo;
  }

  if (document.documentElement.dataset.aiooLocaleReturnBound !== '1') {
    document.documentElement.dataset.aiooLocaleReturnBound = '1';
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      ensureLocalizationReturnTo(form);
    }, true);
  }

  function initLangSwitchers() {
    document.querySelectorAll('[data-aioo-lang-switcher]').forEach(function (root) {
      if (root.dataset.aiooLangBound === '1') return;
      root.dataset.aiooLangBound = '1';

      var trigger = root.querySelector('.aioo-lang-switcher__trigger');
      var menu = root.querySelector('.aioo-lang-switcher__menu');
      var form = root.querySelector('.aioo-lang-switcher__form');
      if (!trigger || !menu) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = trigger.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.aioo-lang-switcher__trigger[aria-expanded="true"]').forEach(function (other) {
          if (other === trigger) return;
          other.setAttribute('aria-expanded', 'false');
          var otherMenu = other.parentElement && other.parentElement.querySelector('.aioo-lang-switcher__menu');
          if (otherMenu) otherMenu.hidden = true;
        });
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
        menu.hidden = open;
      });

      menu.querySelectorAll('.aioo-lang-switcher__option[data-value]').forEach(function (option) {
        option.addEventListener('click', function () {
          if (!form) return;
          var input = form.querySelector('.slcrlg');
          if (input && option.dataset.value) input.value = option.dataset.value;
          ensureLocalizationReturnTo(form);
          form.submit();
        });
        option.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          option.click();
        });
      });
    });

    if (document.documentElement.dataset.aiooLangOutsideBound === '1') return;
    document.documentElement.dataset.aiooLangOutsideBound = '1';

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-aioo-lang-switcher]')) return;
      document.querySelectorAll('.aioo-lang-switcher__trigger[aria-expanded="true"]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        var menu = trigger.parentElement && trigger.parentElement.querySelector('.aioo-lang-switcher__menu');
        if (menu) menu.hidden = true;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLangSwitchers);
  } else {
    initLangSwitchers();
  }

  document.addEventListener('shopify:section:load', initLangSwitchers);

  function expandShortSearchQuery(term) {
    term = (term || '').trim();
    if (!term || term.indexOf('*') !== -1 || term.indexOf(' ') !== -1) return term;
    // Bare numeric queries (Svītrkods/barcode_gms, EAN, any digits-only code)
    // don't reliably match their sku:/barcode:/barcode-gms: search tag
    // without a trailing wildcard, regardless of length -- confirmed live
    // 2026-09-11 ("66950202" -> 0 results, "66950202*" -> 1 correct result).
    // Mirrors snippets/aioo-search-query.liquid, which drives the full
    // /search page the same way this drives the predictive dropdown.
    if (/^[0-9]+$/.test(term)) return term + '*';
    if (term.length < 3) return term + '*';
    if (term.length === 3 && /^[a-zA-Z]{3}$/.test(term)) return term + '*';
    return term;
  }

  function productMatchesSearchTerm(title, vendor, term) {
    var needle = (term || '').trim().replace(/\*+$/, '').toLowerCase();
    if (needle.length < 2) return true;
    var titleHay = (title || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var vendorHay = (vendor || '').toLowerCase().replace(/\s+/g, ' ').trim();
    var re = new RegExp('(^|[\\s\\-_/,(+&])' + needle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
    // Short prefixes: match title word-start only (avoids mid-word "ūdens" and vendor noise).
    if (needle.length <= 3) {
      return !!(titleHay && re.test(titleHay));
    }
    if (titleHay && re.test(titleHay)) return true;
    if (vendorHay && re.test(vendorHay)) return true;
    return false;
  }

  function refinePredictiveProducts(root, term) {
    if (!root) return;
    var list = root.querySelector('.aioo-psearch__product-list');
    if (!list) return;
    // Multi-word queries rely on Shopify's own fuzzy/typo-tolerant matching
    // (e.g. "vačinš" -> "vāciņš"); a literal-phrase re-check here would
    // strip out results that never appear verbatim in the title. Only
    // dedupe in that case, don't re-filter. Mirrors initSearchResultsRefine.
    var needle = (term || '').trim().replace(/\*+$/, '');
    var multiWord = needle.indexOf(' ') !== -1;
    // A numeric code (Svītrkods/barcode_gms, EAN, SKU digits) matches via its
    // sku:/barcode:/barcode-gms: tag on the backend and will legitimately
    // never appear in the visible title/vendor text -- re-filtering on that
    // text would silently drop the correct hit. Same bypass as multiWord.
    var isNumericCode = /^[0-9]+$/.test(needle);
    var seen = {};
    Array.prototype.slice.call(list.querySelectorAll('li')).forEach(function (item) {
      var link = item.querySelector('.aioo-psearch__product');
      var titleEl = item.querySelector('.aioo-psearch__product-title');
      var title = titleEl ? titleEl.textContent : '';
      var href = link ? link.getAttribute('href') || '' : '';
      var key = href.split('?')[0];
      var matches = multiWord || isNumericCode || productMatchesSearchTerm(title, '', term);
      var keep = matches && key && !seen[key];
      if (keep) {
        seen[key] = true;
      } else {
        item.remove();
      }
    });
    if (!list.querySelector('li')) {
      list.remove();
      var productsCol = root.querySelector('.aioo-psearch__products');
      if (productsCol && !productsCol.querySelector('.aioo-psearch__products-empty')) {
        var note = document.createElement('p');
        note.className = 'aioo-psearch__products-empty';
        note.textContent = productsCol.getAttribute('data-empty-label') || '';
        productsCol.appendChild(note);
      }
    }
  }

  function refinePredictiveCategories(root, term) {
    if (!root) return;
    var remainingProducts = Array.prototype.slice.call(root.querySelectorAll('.aioo-psearch__product-title'))
      .map(function (el) { return (el.textContent || '').toLowerCase(); });

    Array.prototype.slice.call(root.querySelectorAll('.aioo-psearch__query-item--collection')).forEach(function (item) {
      var titleEl = item.querySelector('.aioo-psearch__category-title');
      var label = titleEl ? (titleEl.textContent || '').toLowerCase() : '';
      var labelWords = label.split(/\s+/).filter(function (w) { return w.length > 4; });
      var keep = remainingProducts.length > 0 && labelWords.length > 0 && remainingProducts.some(function (pt) {
        return labelWords.some(function (w) { return pt.indexOf(w) !== -1; });
      });
      if (!keep) item.remove();
    });

    Array.prototype.slice.call(root.querySelectorAll('.aioo-psearch__category-group')).forEach(function (group) {
      var list = group.nextElementSibling;
      if (!list || !list.classList.contains('aioo-psearch__query-list') || !list.querySelector('li')) {
        group.remove();
        if (list && list.classList.contains('aioo-psearch__query-list')) list.remove();
      }
    });

    var facetRoot = root.querySelector('[data-aioo-facet-categories]');
    if (facetRoot && !facetRoot.querySelector('.aioo-psearch__query-item--collection')) {
      facetRoot.remove();
      var cols = root.querySelector('.aioo-psearch__cols');
      var suggestions = root.querySelector('.aioo-psearch__suggestions');
      if (suggestions && !suggestions.querySelector('.aioo-psearch__query-item')) {
        suggestions.remove();
        if (cols) cols.classList.add('aioo-psearch__cols--products-only');
      }
    }
  }

  function initSearchResultsRefine() {
    var grid = document.getElementById('GridContainer');
    if (!grid || !grid.hasAttribute('data-aioo-search-refine')) return;
    var term = grid.getAttribute('data-aioo-search-refine') || '';
    var raw = grid.getAttribute('data-aioo-search-raw') || '';
    var needle = (term || raw || '').trim().replace(/\*+$/, '');
    if (needle.length < 2 || needle.length > 4) return;
    if (needle.indexOf(' ') !== -1) return;

    /* ?view=list renders .list-view-item instead of .gitem — match both. */
    var CARD_SELECTOR = '.gitem, .list-view-item';
    var hidden = 0;
    Array.prototype.slice.call(grid.querySelectorAll(CARD_SELECTOR)).forEach(function (item) {
      var title = item.getAttribute('data-aioo-search-title') || '';
      var vendor = item.getAttribute('data-aioo-search-vendor') || '';
      if (!productMatchesSearchTerm(title, vendor, needle)) {
        item.style.display = 'none';
        item.setAttribute('data-aioo-search-hidden', '1');
        hidden += 1;
      }
    });

    var visible = grid.querySelectorAll('.gitem:not([data-aioo-search-hidden]), .list-view-item:not([data-aioo-search-hidden])').length;
    if (visible === 0 && hidden > 0) {
      var lang = (document.documentElement.lang || '').toLowerCase();
      var msg;
      if (lang.indexOf('ru') === 0) msg = 'Нет точных совпадений по запросу «' + needle + '»';
      else if (lang.indexOf('en') === 0) msg = 'No exact matches for «' + needle + '»';
      else msg = 'Nav precīzu rezultātu meklējumam «' + needle + '»';
      var empty = document.createElement('div');
      empty.className = 'gitem small--tc aioo-search-refined-empty';
      empty.innerHTML = '<p class="tc" style="margin:40px 0;">' + msg + '</p>';
      grid.appendChild(empty);
    }
  }

  function syncPredictiveFooterLink(root, term) {
    if (!root) return;
    var footer = root.querySelector('.aioo-psearch__footer');
    if (!footer) return;
    var expanded = expandShortSearchQuery(term);
    var subtype = resolveSearchIntent(term);
    var url = '/search?q=' + encodeURIComponent(expanded) + '&type=product&options%5Bprefix%5D=last';
    if (subtype) {
      url += '&filter.p.m.custom.subtype=' + encodeURIComponent(subtype);
    }
    footer.setAttribute('href', url);
  }

  function resolveSearchIntent(term) {
    var q = (term || '').toLowerCase().trim();
    if (/vāciņ|vacin|maciņ|macin|aizsarg|stikl|kabel|lādēt|ladet|charger|case|cover|aksesuar/.test(q)) {
      return null;
    }
    if (/lietot|mazlietot|\bused\b/.test(q)) {
      return 'Mazlietots telefons';
    }
    return null;
  }

  function applySearchIntentToForm(form, rawTerm) {
    if (!form) return;
    var subtype = resolveSearchIntent(rawTerm);
    var hidden = form.querySelector('[data-aioo-search-subtype-filter]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'filter.p.m.custom.subtype';
      hidden.setAttribute('data-aioo-search-subtype-filter', '');
      form.appendChild(hidden);
    }
    if (subtype) {
      hidden.value = subtype;
      hidden.disabled = false;
    } else {
      hidden.value = '';
      hidden.disabled = true;
    }
  }

  function initSearchFormWildcards() {
    document.querySelectorAll('form.search-header').forEach(function (form) {
      if (form.dataset.aiooSearchWildcardBound === '1') return;
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.dataset.aiooSearchWildcardBound = '1';
      form.addEventListener('submit', function () {
        var raw = input.value || '';
        applySearchIntentToForm(form, raw);
        input.value = expandShortSearchQuery(raw);
      });
    });
  }

  /* Desktop header search: smart dropdown, submit gate (min 2 chars), keyboard shortcuts */
  function initHeaderSearch() {
    var input = document.getElementById('HeaderSearchInput');
    var root = document.querySelector('[data-header-search]')
      || (input && input.closest('.header-search-wrap'))
      || (input && input.closest('.header-search'));
    if (!root || root.dataset.aiooHeaderSearchBound === '1') return;

    var form = document.getElementById('HeaderSearchForm') || root.querySelector('[data-header-search-form]');
    var results = document.getElementById('HeaderSearchResults') || root.querySelector('.header-search-results');
    var clearBtn = root.querySelector('.header-search__clear');
    var submitBtn = root.querySelector('.search__submit--header');
    var popularTpl = document.getElementById('HeaderSearchPopularTpl');
    if (!form || !input) return;

    root.dataset.aiooHeaderSearchBound = '1';

    var debounceTimer = null;
    var fetchController = null;
    var MIN_CHARS = 2;

    function setExpanded(open) {
      input.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function showResults() {
      if (!results) return;
      results.hidden = false;
      results.style.display = '';
      setExpanded(true);
    }

    function hideResults() {
      if (!results) return;
      results.hidden = true;
      results.style.display = 'none';
      results.innerHTML = '';
      setExpanded(false);
    }

    function updateControls() {
      var term = (input.value || '').trim();
      var canSearch = term.length >= MIN_CHARS;

      if (submitBtn) {
        submitBtn.disabled = !canSearch;
        submitBtn.setAttribute('aria-disabled', canSearch ? 'false' : 'true');
        submitBtn.classList.toggle('is-ready', canSearch);
      }

      if (clearBtn) {
        clearBtn.hidden = term.length === 0;
      }
    }

    function showPopular() {
      if (!results || !popularTpl) return;
      results.innerHTML = popularTpl.innerHTML;
      showResults();
    }

    function buildFacetCategoriesUrl(term) {
      var q = expandShortSearchQuery(term);
      var url = '/search?q=' + encodeURIComponent(q) + '&type=product&section_id=aioo-search-facet-categories';
      var subtype = resolveSearchIntent(term);
      if (subtype) {
        url += '&filter.p.m.custom.subtype=' + encodeURIComponent(subtype);
      }
      return url;
    }

    function mergeFacetCategories(root) {
      if (!root) return;
      var slot = root.querySelector('[data-aioo-categories-slot]');
      if (!slot) return;
      var facetBlock = slot.querySelector('[data-aioo-facet-categories]');
      if (facetBlock && facetBlock.innerHTML.trim() !== '') {
        slot.replaceWith(facetBlock);
        var cols = root.querySelector('.aioo-psearch__cols');
        if (cols) cols.classList.remove('aioo-psearch__cols--products-only', 'aioo-psearch__cols--await-categories');
        return;
      }
      slot.remove();
      var suggestions = root.querySelector('.aioo-psearch__suggestions');
      var hasQueries = root.querySelector('.aioo-psearch__query-list:not(.aioo-psearch__query-list--categories)');
      if (suggestions && !hasQueries) {
        suggestions.remove();
        var cols = root.querySelector('.aioo-psearch__cols');
        if (cols) cols.classList.add('aioo-psearch__cols--products-only');
      }
    }

    function fetchPredictive(term) {
      if (!results || !window.routes || !window.routes.predictive_search_url) return;

      if (fetchController) fetchController.abort();
      fetchController = new AbortController();
      var signal = fetchController.signal;

      var predictiveUrl = window.routes.predictive_search_url
        + '?q=' + encodeURIComponent(expandShortSearchQuery(term))
        + '&resources[type]=query,product'
        + '&resources[limit]=10'
        + '&resources[limit_scope]=each'
        + '&section_id=predictive-search-header';

      Promise.all([
        fetch(predictiveUrl, { signal: signal }),
        fetch(buildFacetCategoriesUrl(term), { signal: signal })
      ])
        .then(function (responses) {
          return Promise.all(responses.map(function (response) {
            if (!response.ok) throw new Error(String(response.status));
            return response.text();
          }));
        })
        .then(function (texts) {
          var doc = new DOMParser().parseFromString(texts[0], 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search-header');
          if (!section || !section.innerHTML.trim()) {
            hideResults();
            return;
          }
          results.innerHTML = section.innerHTML;

          var facetDoc = new DOMParser().parseFromString(texts[1], 'text/html');
          var facetSection = facetDoc.querySelector('#shopify-section-aioo-search-facet-categories');
          var slot = results.querySelector('[data-aioo-categories-slot]');
          if (slot && facetSection) {
            slot.innerHTML = facetSection.innerHTML;
          }
          refinePredictiveProducts(results, term);
          syncPredictiveFooterLink(results, term);
          mergeFacetCategories(results);
          refinePredictiveCategories(results, term);
          showResults();
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          hideResults();
        });
    }

    function scheduleFetch() {
      window.clearTimeout(debounceTimer);
      var term = (input.value || '').trim();
      updateControls();

      if (term.length < MIN_CHARS) {
        if (fetchController) fetchController.abort();
        hideResults();
        return;
      }

      debounceTimer = window.setTimeout(function () {
        fetchPredictive(term);
      }, 220);
    }

    input.addEventListener('input', scheduleFetch);
    input.addEventListener('change', scheduleFetch);

    input.addEventListener('focus', function () {
      var term = (input.value || '').trim();
      if (term.length >= MIN_CHARS) {
        if (results && results.innerHTML.trim() !== '') {
          showResults();
        } else {
          scheduleFetch();
        }
      } else if (popularTpl) {
        showPopular();
      }
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hideResults();
        input.blur();
        return;
      }
      if (e.key === 'Enter' && (input.value || '').trim().length < MIN_CHARS) {
        e.preventDefault();
      }
    });

    form.addEventListener('submit', function (e) {
      var raw = input.value || '';
      if (raw.trim().length < MIN_CHARS) {
        e.preventDefault();
        return;
      }
      applySearchIntentToForm(form, raw);
      input.value = expandShortSearchQuery(raw);
    });

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        if ((input.value || '').trim().length < MIN_CHARS) e.preventDefault();
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        updateControls();
        hideResults();
        if (popularTpl) showPopular();
        input.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) hideResults();
    });

    document.addEventListener('keydown', function (e) {
      if (!(e.metaKey || e.ctrlKey) || e.key.toLowerCase() !== 'k') return;
      if (e.target.closest('input, textarea, select, [contenteditable="true"]')) return;
      e.preventDefault();
      input.focus();
      input.select();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
      var tag = e.target && e.target.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (e.target && e.target.isContentEditable)) return;
      e.preventDefault();
      input.focus();
    });

    updateControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      try { initSearchResultsRefine(); } catch (e) {}
      try { initSearchFormWildcards(); } catch (e) {}
      try { initHeaderSearch(); } catch (e) {}
    });
  } else {
    try { initSearchResultsRefine(); } catch (e) {}
    try { initSearchFormWildcards(); } catch (e) {}
    try { initHeaderSearch(); } catch (e) {}
  }

  document.addEventListener('shopify:section:load', function () {
    try { initSearchResultsRefine(); } catch (e) {}
    try { initSearchFormWildcards(); } catch (e) {}
    try { initHeaderSearch(); } catch (e) {}
  });

  window.addEventListener('pageshow', function () {
    try { initSearchResultsRefine(); } catch (e) {}
  });

  /**
   * Quick-add popup: shown after "Add to cart" instead of opening the
   * full cart-drawer (which stays reserved for the header cart icon).
   * Compact confirmation of the item just added + a small cross-sell
   * row, reusing the site's existing quick-view-style magnificPopup
   * modal chrome (.mfpbox) so it matches the rest of the site.
   */
  function qapEscapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function qapFormatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) { /* fall through */ }
    return '€' + (cents / 100).toFixed(2);
  }

  function qapVariantLine(item) {
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    return '<p class="qap__variant">' + qapEscapeHtml(item.variant_title) + '</p>';
  }

  function qapBuildHtml(item) {
    var strings = window.cartStrings || {};
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var price = item.final_price != null ? item.final_price : item.price;
    return (
      '<div class="qap">' +
        '<div class="qap__item">' +
          (item.image ? '<div class="qap__img"><img src="' + item.image + '" alt="' + qapEscapeHtml(item.product_title) + '" width="72" height="72" loading="lazy"></div>' : '') +
          '<div class="qap__info">' +
            '<p class="qap__added"><i class="at at-check-circle-r" aria-hidden="true"></i> ' + qapEscapeHtml(strings.added || 'Added to cart') + '</p>' +
            '<p class="qap__title">' + qapEscapeHtml(item.product_title) + '</p>' +
            qapVariantLine(item) +
            '<p class="qap__price"><span class="money">' + qapFormatMoney(price) + '</span></p>' +
          '</div>' +
        '</div>' +
        '<div class="qap__ctas">' +
          '<a href="' + cartUrl + '" class="btn qap__checkout">' + qapEscapeHtml(strings.checkout || 'Checkout') + '</a>' +
          '<button type="button" class="btn btn2 qap__continue">' + qapEscapeHtml(strings.continueShopping || 'Continue shopping') + '</button>' +
        '</div>' +
        '<div class="qap__recs" data-url="' + qapRecsUrl(item) + '"></div>' +
      '</div>'
    );
  }

  function qapRecsUrl(item) {
    if (!item.url) return '';
    var base = item.url.split('?')[0];
    return base + '?sections=quick-add-recommendations';
  }

  function qapInitRecsCarousel(container) {
    var el = container.querySelector('[data-flickity]');
    if (!el) return;
    var cells = el.querySelectorAll('.gitem');
    // Few items + narrow popup: native horizontal scroll is more predictable
    // than Flickity (which was stretching the viewport to full PDP card height).
    if (cells.length <= 4) {
      el.classList.add('qap-recs__strip');
      el.removeAttribute('data-flickity');
      return;
    }
    if (!window.Flickity) return;
    try {
      var opts = JSON.parse(el.getAttribute('data-flickity') || '{}');
      opts.groupCells = false;
      opts.wrapAround = false;
      opts.prevNextButtons = false;
      opts.pageDots = false;
      opts.contain = true;
      opts.adaptiveHeight = false;
      new Flickity(el, opts);
    } catch (e) { /* non-blocking */ }
  }

  function qapLoadRecs(container) {
    var url = container && container.getAttribute('data-url');
    if (!container || !url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data && data['quick-add-recommendations'];
        if (!html) { container.remove(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var related = doc.querySelector('.related-product');
        if (!related || !related.textContent.trim()) { container.remove(); return; }
        container.innerHTML = related.outerHTML;
        qapInitRecsCarousel(container);
      })
      .catch(function () { container.remove(); });
  }

  // `overflow:hidden` on html/body alone doesn't stop touch-scroll on iOS
  // Safari, so the fixed popup can appear to drift/vanish as the background
  // page scrolls underneath it. Pin the body in place instead (standard
  // cross-browser modal scroll-lock) and restore the exact scroll position
  // on close.
  var qapScrollY = 0;
  function qapLockScroll() {
    qapScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + qapScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function qapUnlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, qapScrollY);
  }

  window.AIOO_openQuickAddPopup = function (item) {
    try {
      if (!window.jQuery || !jQuery.magnificPopup || !item) return false;
      jQuery.magnificPopup.open({
        items: { src: '<div class="qap-popup mfpbox mfp-with-anim" id="QuickAddPopup">' + qapBuildHtml(item) + '</div>', type: 'inline' },
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        callbacks: {
          open: function () {
            qapLockScroll();
            var root = document.getElementById('QuickAddPopup');
            if (!root) return;
            var continueBtn = root.querySelector('.qap__continue');
            if (continueBtn) continueBtn.addEventListener('click', function () { jQuery.magnificPopup.close(); });
            var recs = root.querySelector('.qap__recs');
            if (recs) qapLoadRecs(recs);
            if (window.theme && theme.mlcurrency && typeof currenciesChange === 'function') {
              currenciesChange('#QuickAddPopup .money');
            }
          },
          close: function () {
            qapUnlockScroll();
            var root = document.getElementById('QuickAddPopup');
            if (root) root.innerHTML = '';
          }
        }
      });
      // Cart-drawer content is now stale (new item not reflected) — force a
      // fresh fetch next time the header cart icon opens it.
      var cd = document.querySelector('cart-drawer');
      if (cd) cd.setAttribute('data-aioo-lazy', 'pending');
      return true;
    } catch (e) {
      return false;
    }
  };
})();
